import BaseService from '@/services-ts/BaseService'
import type { IBorderedEmployee, IEmployee, IEmployeeByFilter } from '@/types/Data'
import type {
  IGetBorderedEmployeeList,
  IGetEmployeeList,
  IGetEmployeeListByFilter,
  IPayloadEmployee,
  IPayloadEmployeeBorders,
} from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'

export default class EmployeeServices extends BaseService {
  GetEmployeeList(payload: IGetEmployeeList) {
    return this.GET<IEmployee[]>(this.PATHS.GET_EMPLOYEE_LIST, payload)
  }

  GetEmployeeListByFilter(payload: IGetEmployeeListByFilter) {
    return this.GET<IEmployeeByFilter[]>(this.PATHS.GET_EMPLOYEE_LIST_BY_FILTER, payload)
  }

  CreateEmployee(payload: IPayloadEmployee) {
    return this.POST<void>(this.PATHS.CREATE_EMPLOYEE, JsonToFormData(payload))
  }

  UpdateEmployee(data: IPayloadEmployee) {
    return this.POST<void>(this.PATHS.UPDATE_EMPLOYEE, JsonToFormData(data))
  }

  DeleteEmployee(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_EMPLOYEE, { Id })
  }

  AnonymizeEmployee(EmployeeId: string) {
    return this.POST<void>(this.PATHS.ANONYMIZE_EMPLOYEE, { EmployeeId })
  }

  GetEmployeeByIdWeb() {
    return this.GET<IEmployee>(this.PATHS.GET_EMPLOYEE_BY_ID_WEB)
  }

  GetBorderedEmployeeList(payload: IGetBorderedEmployeeList) {
    return this.GET<IBorderedEmployee[]>(this.PATHS.GET_BORDERED_EMPLOYEE_LIST, payload)
  }

  UpdateEmployeeBorders(payload: IPayloadEmployeeBorders) {
    return this.POST<boolean>(this.PATHS.UPDATE_EMPLOYEE_BORDERS, payload)
  }
}
